import dayjs from 'dayjs';
import { randomDate, randomEnum, randomFloat, randomInteger, randomUUID } from 'utils/random';
import {
  ScenarioCageData,
  ScenarioHarvestTargetType,
} from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-cage-data.type';
import mockFeedProgram from 'views/bluviu-nutrition/features/scenarios-v2/mock/feed-program.mock';

/**
 * Generates a random CageData object array.
 *
 * @param count The number of cage data entries to generate. Defaults to 5.
 * @returns {ScenarioCageData[]} A randomly generated CageData object array.
 */
function getRandomCageData(count = 5): ScenarioCageData[] {
  const fishGroupNames = [
    'Atlantic Salmon G1',
    'Atlantic Salmon G2',
    'AS Smolt 2024-1',
    'AS Smolt 2024-2',
    'AS Smolt 2025-1',
    'Trout Gen A',
    'Trout Gen B',
  ];

  const mortalityProfiles = [
    { id: 1, name: 'Standard Mortality' },
    { id: 2, name: 'Low Mortality' },
    { id: 3, name: 'High Mortality' },
    { id: 4, name: 'Post-Smolt Profile' },
  ];

  return Array.from({ length: count }, (_, i) => {
    const mortalityProfile = mortalityProfiles[randomInteger(mortalityProfiles.length - 1)];
    // Stocking typically 6–18 months before now; start date within the last 90 days
    const stockingDate = dayjs()
      .subtract(randomInteger(180) + 180, 'days')
      .toISOString();
    const startDate = dayjs().subtract(randomInteger(90), 'days').toISOString();

    return {
      id: randomUUID(),
      fishGroupId: randomUUID(),
      fishGroupName: fishGroupNames[randomInteger(fishGroupNames.length - 1)],
      fishCount: randomInteger(150000) + 50000, // 50k–200k fish per cage
      meanWeight: parseFloat((randomFloat(4900, 1) + 100).toFixed(1)), // 100g–5000g
      harvestTarget: randomInteger(52) + 1,
      harvestTargetType: randomEnum(ScenarioHarvestTargetType),
      startDate,
      stockingDate,
      fetchedAt: randomDate(7, true),
      seaCloudLastUpdated: randomDate(7, true),
      estimatedHarvestDate: randomDate(7, true),
      isVirtual: Math.random() < 0.2, // ~20% chance of virtual cage
      isUserEdited: Math.random() < 0.15, // ~15% chance of manual edits
      isIncluded: Math.random() > 0.1, // ~90% included by default
      unitName: 'kg',
      feedProgram: mockFeedProgram,
      mortalityProfileId: mortalityProfile.id,
      mortalityProfileName: mortalityProfile.name,
    };
  });
}

const mockCageData: ScenarioCageData[] = getRandomCageData(5);

export default mockCageData;
